export enum MaterialType {
  Default = 'DEFAULT',
  Welcome = 'WELCOME'
}
